import React, { useState, useEffect } from 'react';
import { Card, Form, Button, message } from "antd";
import { PollInfo } from '../../pages/vote/Vote';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useNavigate } from 'react-router-dom';


interface DragDropProps {
    requestUrl: string
    pollinfo: PollInfo | undefined
    voteToken: string | undefined
    id: undefined | string,
}

interface Ballot {
    "ballot": number[],
    "vote_token": string
  }

const DragDrop:React.FC<DragDropProps> = ( { requestUrl, pollinfo, voteToken, id } ) => {
    const [options, setOptions] = useState(pollinfo?.options)
    const [requestBody, setRequestBody] = useState<Ballot | undefined>(undefined)
    const navigate = useNavigate()

    const onFinish = () => {
        const ballot = options?.map(({position , content}) => {
            return position
        })

        if(voteToken && ballot) {
            setRequestBody({
                "ballot": ballot,
                  "vote_token": voteToken
            })
        }
    }
      
    /////// Any? //////
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    const handleOnDragEnd = (result: any) => {
        if(options) {
            if(!result.destination) return;
            const items = Array.from(options);
            const [reorderedItem] = items.splice(result.source.index, 1);
            items.splice(result.destination.index, 0, reorderedItem);

            setOptions(items)
        }
    }

    useEffect(() => {
        if(requestBody) {
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            }
            fetch(`${requestUrl}/polling/polls/${id}/vote/`, requestOptions)
                .then(response => {
                    if(response.status === 401) {
                        message.error('You have already voted.')
                        navigate('/')
                    } else if( response.status === 200) {
                        message.success('Vote is submited')
                        navigate('/')
                    }
                })
                .catch(error => console.log('error', error))
        }
    }, [requestBody, id, requestUrl, navigate])

    return(
        <div className='vote_content_card'>
            <Card title="Vote" className='vote_card_inner'>
                <Form
                    name="basic"
                    wrapperCol={{
                        span: 24,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off" >
                    
                    <Form.Item>
                        <h3>{pollinfo?.question}</h3>
                    </Form.Item>

                    <Form.Item
                        name="vote_token">
                            <DragDropContext onDragEnd={handleOnDragEnd}>
                                <Droppable droppableId='options'>
                                    {(provided) => (
                                        <ul {...provided.droppableProps} ref={provided.innerRef}  style={{listStyleType:'none', padding:0, margin:0}}>
                                            {options?.map((option: {position:number, content:string}, index) => {
                                                return (
                                                    <Draggable key={option.position} draggableId={option.position.toString()} index={index}>
                                                        {(provided) => (
                                                            <li {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                                <Card>
                                                                    <p style={{margin:0}}>{option.content}</p>
                                                                </Card>
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                )
                                            })}
                                            {provided.placeholder}
                                        </ul> 
                                    )}
                                </Droppable>
                            </DragDropContext>
                                                            
                    </Form.Item>

                    <Form.Item
                        wrapperCol={{
                        offset: 0,
                        span: 24,
                        }}>
                        <Button block type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default DragDrop